import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types/AppState";
import Component, { type MapProps } from "./component";
import { localStateSelector } from "./selectors";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const { status, step } = localStateSelector(state, props);
    return {
      ...props,
      isEditMode: state.isEditMode,
      status,
      step
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
